import {
  ICheckoutMeta,
  ICheckoutMetaData
} from './index'

export class CheckoutMeta implements ICheckoutMeta {
  readonly order: string
  readonly customer?: number

  constructor(data: ICheckoutMetaData) {
    this.order = data.order
    this.customer = data.customer
  }
}